if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Vertical Slider Component for columns_slider layout
if (!customElements.get('slider-vertical-component')) {
  customElements.define(
    'slider-vertical-component',
    class SliderVerticalComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.product__media-list-vertical');
        this.slides = this.querySelectorAll('.product__media-item-vertical');
        this.prevButton = this.querySelector('.slider-button-vertical--prev');
        this.nextButton = this.querySelector('.slider-button-vertical--next');
        this.currentIndex = 0;

        if (this.slides.length <= 1) return;

        this.init();
      }

      init() {
        // Setup button event listeners
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.scrollToPrevious());
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.scrollToNext());
        }

        // Update buttons visibility based on scroll position
        this.slider.addEventListener('scroll', () => this.updateButtonsVisibility());
        this.updateButtonsVisibility();
      }

      scrollToPrevious() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.scrollToSlide(this.currentIndex);
        }
      }

      scrollToNext() {
        if (this.currentIndex < this.slides.length - 1) {
          this.currentIndex++;
          this.scrollToSlide(this.currentIndex);
        }
      }

      scrollToSlide(index) {
        const slide = this.slides[index];
        if (slide) {
          const scrollPosition = slide.offsetTop - this.slider.offsetTop;
          this.slider.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
          });
        }
      }

      updateButtonsVisibility() {
        if (!this.prevButton || !this.nextButton) return;

        const isAtTop = this.slider.scrollTop <= 10;
        const isAtBottom = this.slider.scrollTop + this.slider.clientHeight >= this.slider.scrollHeight - 10;

        this.prevButton.style.opacity = isAtTop ? '0.3' : '1';
        this.prevButton.style.pointerEvents = isAtTop ? 'none' : 'auto';

        this.nextButton.style.opacity = isAtBottom ? '0.3' : '1';
        this.nextButton.style.pointerEvents = isAtBottom ? 'none' : 'auto';
      }
    }
  );
}

// Custom Cursor for Zoom In & Zoom Out
document.addEventListener('DOMContentLoaded', function () {
  // Helper function to calculate brightness from RGB
  function getBrightness(r, g, b) {
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  // Helper function to get pixel color from image
  function getImagePixelColor(img, x, y) {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;

      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      const rect = img.getBoundingClientRect();
      const relativeX = Math.floor(((x - rect.left) / rect.width) * canvas.width);
      const relativeY = Math.floor(((y - rect.top) / rect.height) * canvas.height);

      const pixelData = ctx.getImageData(relativeX, relativeY, 1, 1).data;
      return {
        r: pixelData[0],
        g: pixelData[1],
        b: pixelData[2],
      };
    } catch (error) {
      return null;
    }
  }

  // Zoom In Cursor for Product Gallery
  const productModalOpeners = document.querySelectorAll('.product__modal-opener--image');
  productModalOpeners.forEach((opener) => {
    opener.addEventListener('mousemove', function (e) {
      this.style.setProperty('--mouse-x', e.clientX + 'px');
      this.style.setProperty('--mouse-y', e.clientY + 'px');

      const img = this.querySelector('img');
      if (img && img.complete) {
        const pixelColor = getImagePixelColor(img, e.clientX, e.clientY);
        if (pixelColor) {
          const brightness = getBrightness(pixelColor.r, pixelColor.g, pixelColor.b);
          const textColor = brightness > 128 ? '#000000' : '#ffffff';
          this.style.setProperty('--cursor-color', textColor);
        }
      } else {
        this.style.setProperty('--cursor-color', '#000000');
      }
    });
  });

  // Zoom Out Cursor for Modal with Magnification
  const setupModalCursor = () => {
    const modal = document.querySelector('.media-modal[open], .product-media-modal[open]');
    if (modal) {
      // Remove existing listeners
      modal.removeEventListener('mousemove', handleModalMouseMove);
      modal.removeEventListener('mouseleave', handleModalMouseLeave);

      // Add listeners to modal itself
      modal.addEventListener('mousemove', handleModalMouseMove);
      modal.addEventListener('mouseleave', handleModalMouseLeave);

      console.log('Modal cursor setup completed');
    }
  };

  function handleModalMouseMove(e) {
    // Update cursor position
    this.style.setProperty('--mouse-x-modal', e.clientX + 'px');
    this.style.setProperty('--mouse-y-modal', e.clientY + 'px');

    // Find modal content
    const modalContent = this.querySelector('.product-media-modal__content');
    if (modalContent) {
      // Find image - try multiple selectors
      const img =
        e.target.closest('.global-media-settings')?.querySelector('img') ||
        e.target.closest('img') ||
        modalContent.querySelector('.global-media-settings.active img') ||
        modalContent.querySelector('.global-media-settings img');

      if (img) {
        const rect = img.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        // Set zoom origin on the image itself
        img.style.setProperty('--zoom-x', `${x}%`);
        img.style.setProperty('--zoom-y', `${y}%`);

        // Get pixel color for cursor
        if (img.complete) {
          const pixelColor = getImagePixelColor(img, e.clientX, e.clientY);
          if (pixelColor) {
            const brightness = getBrightness(pixelColor.r, pixelColor.g, pixelColor.b);
            const textColor = brightness > 128 ? '#000000' : '#ffffff';
            this.style.setProperty('--cursor-color-modal', textColor);
          }
        }
      }
    } else {
      this.style.setProperty('--cursor-color-modal', '#000000');
    }
  }

  function handleModalMouseLeave(e) {
    // Reset zoom when mouse leaves modal
    const modalContent = this.querySelector('.product-media-modal__content');
    if (modalContent) {
      const images = modalContent.querySelectorAll('img');
      images.forEach((img) => {
        img.style.removeProperty('--zoom-x');
        img.style.removeProperty('--zoom-y');
      });
    }
  }

  // Watch for modal opening
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        setupModalCursor();
      }
    });
  });

  // Observe all product-media-modal elements
  const observeModals = () => {
    const modals = document.querySelectorAll('.media-modal, .product-media-modal');
    modals.forEach((modal) => {
      observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  };

  // Initial setup
  observeModals();

  // Also observe body for dynamically added modals
  const bodyObserver = new MutationObserver(() => {
    observeModals();
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
});
